// src/components/store/sections/hero-banner/HeroV47GlassislandCoralFlame.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV47GlassislandCoralFlame(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={47}
      archKey="glass_island"
      archLabel="Frosted Glass Island"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      {...props}
    />
  );
}
